import { buildTestId, Select, SELECT_MODES } from '@avodah-inc/connect-ui';
import { ChangeEventHandler, useState } from 'react';
import { getLocalStorageValue, localStorageKey } from '@/utils/utils';
import i18n from '@i18n/i18n.config';

interface ChangeLanguageProps {
  dataTestId?: string;
}
const ChangeLanguage = ({ dataTestId = 'login-form' }: ChangeLanguageProps) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => getLocalStorageValue(localStorageKey.defaultLocalLanguage, 'en'));

  const languageOptions = [
    {
      value: 'en',
      label: 'English',
    },
    {
      value: 'es',
      label: 'Español',
    },
    {
      value: 'fr',
      label: 'Français',
    },
    {
      value: 'id',
      label: 'Indonesia',
    },
    {
      value: 'ar',
      label: 'عربي',
    },
  ];
  const handleLanguageChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
    const value = e.target.value;

    if (i18n.language !== value) {
      i18n.changeLanguage(value);
      localStorage.setItem(localStorageKey.defaultLocalLanguage, value);
      setCurrentLanguage(value);

      document.documentElement.lang = value;
      document.documentElement.dir = value === 'ar' ? 'rtl' : 'ltr';
    }
  };
  return (
    <div className="language-selection">
      <Select
        dataTestId={buildTestId(dataTestId)}
        id="language-select"
        onChange={e => handleLanguageChange(e)}
        mode={SELECT_MODES.TEXT}
        className="no-border"
        iconProps={{
          name: 'Globe',
          type: 'Regular',
        }}
        defaultValue={currentLanguage}
        options={languageOptions}
        isRequired
      />
    </div>
  );
};

export default ChangeLanguage;
